import { render, staticRenderFns } from "./BannerStatic.vue?vue&type=template&id=89716628&scoped=true&"
import script from "./BannerStatic.vue?vue&type=script&lang=js&"
export * from "./BannerStatic.vue?vue&type=script&lang=js&"
import style0 from "./BannerStatic.vue?vue&type=style&index=0&id=89716628&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89716628",
  null
  
)

export default component.exports